// <div
//   _ngcontent-ng-c1798067373=""
//   className="center-main-container casino-page ng-tns-c1798067373-0 ng-star-inserted"
// >
//   <div
//     _ngcontent-ng-c1798067373=""
//     className="center-container ng-tns-c1798067373-0"
//   >
//     <div
//       _ngcontent-ng-c1798067373=""
//       className="casino-page-container ng-tns-c1798067373-0"
//     >
//       <div
//         _ngcontent-ng-c1798067373=""
//         className="casino-title-header-mobile d-xl-none ng-tns-c1798067373-0"
//       >
//         <ul
//           _ngcontent-ng-c1798067373=""
//           className="nav nav-tabs menu-tabs ng-tns-c1798067373-0"
//         >
//           <li
//             _ngcontent-ng-c1798067373=""
//             className="nav-item ng-tns-c1798067373-0"
//           >
//             <div
//               _ngcontent-ng-c1798067373=""
//               className="ng-tns-c1798067373-0 active nav-link"
//             >
//               Game
//             </div>
//           </li>
//           <li
//             _ngcontent-ng-c1798067373=""
//             className="nav-item ng-tns-c1798067373-0"
//           >
//             <div
//               _ngcontent-ng-c1798067373=""
//               className="ng-tns-c1798067373-0 nav-link"
//             >
//               {" "}
//               Placed Bet (0){" "}
//             </div>
//           </li>
//         </ul>
//         <div
//           _ngcontent-ng-c1798067373=""
//           className="pe-2 ng-tns-c1798067373-0"
//         >
//           <span
//             _ngcontent-ng-c1798067373=""
//             className="casino-rid ng-tns-c1798067373-0"
//           >
//             <a
//               _ngcontent-ng-c1798067373=""
//               className="d-block ng-tns-c1798067373-0"
//             >
//               <small
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0"
//               >
//                 Rules
//               </small>
//             </a>{" "}
//             Round ID:{" "}
//             <span
//               _ngcontent-ng-c1798067373=""
//               className="ng-tns-c1798067373-0 ng-star-inserted"
//             >
//               6326709624791
//             </span>
//             {/**/}
//           </span>
//         </div>
//       </div>
//       <div
//         _ngcontent-ng-c1798067373=""
//         className="casino-header ng-tns-c1798067373-0"
//       >
//         <span
//           _ngcontent-ng-c1798067373=""
//           className="casino-name ng-tns-c1798067373-0"
//         >
//           {" "}
//           Ball by Ball
//           <a
//             _ngcontent-ng-c1798067373=""
//             className="ms-1 d-xl-inline d-none ng-tns-c1798067373-0"
//           >
//             <small
//               _ngcontent-ng-c1798067373=""
//               className="ng-tns-c1798067373-0"
//             >
//               Rules
//             </small>
//           </a>
//         </span>
//         <span
//           _ngcontent-ng-c1798067373=""
//           className="casino-rid d-none d-xl-inline-block ng-tns-c1798067373-0"
//         >
//           <small
//             _ngcontent-ng-c1798067373=""
//             className="ng-tns-c1798067373-0"
//           >
//             Round ID:{" "}
//             <span
//               _ngcontent-ng-c1798067373=""
//               className="ng-tns-c1798067373-0 ng-star-inserted"
//             >
//               6326709624791
//             </span>
//             {/**/}
//           </small>
//           <span
//             _ngcontent-ng-c1798067373=""
//             className="ng-tns-c1798067373-0 ng-star-inserted"
//           >
//             {" "}
//             | Min: 0 {/**/}
//             {/**/} | Max: 0 {/**/}
//             {/**/}
//           </span>
//           {/**/}
//         </span>
//       </div>
//       {/**/}
//       {/**/}
//       <div
//         _ngcontent-ng-c1798067373=""
//         className="ng-tns-c1798067373-0 ng-star-inserted"
//       >
//         <div
//           _ngcontent-ng-c1798067373=""
//           className="casino-video ng-tns-c1798067373-0"
//         >
//           <div
//             _ngcontent-ng-c1798067373=""
//             className="video-box-container ng-tns-c1798067373-0"
//           >
//             <div
//               _ngcontent-ng-c1798067373=""
//               className="casino-video-box ng-tns-c1798067373-0 ng-star-inserted"
//             >
//               <iframe
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0"
//                 src="https://alpha-n.qnsports.live/route/?id=3061"
//               />
//             </div>
//             {/**/}
//           </div>
//           <div
//             _ngcontent-ng-c1798067373=""
//             className="ng-tns-c1798067373-0 ng-star-inserted"
//           >
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//             {/**/}
//           </div>
//           {/**/}
//           <div
//             _ngcontent-ng-c1798067373=""
//             className="clock ng-tns-c1798067373-0"
//           >
//             <div
//               _ngcontent-ng-c1798067373=""
//               className="count-no ng-tns-c1798067373-0 ng-star-inserted"
//             >
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0"
//               >
//                 <div
//                   _ngcontent-ng-c1798067373=""
//                   className="content ng-tns-c1798067373-0"
//                 >
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     style={{ position: "absolute" }}
//                     className="ng-tns-c1798067373-0"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       className="flip ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="up ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="ng-tns-c1798067373-0"
//                         >
//                           1
//                         </div>
//                       </div>
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="down ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="ng-tns-c1798067373-0"
//                           >
//                             5
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     style={{ position: "absolute" }}
//                     className="ng-tns-c1798067373-0"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       className="flip-card ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="flip-card-inner ng-tns-c1798067373-0 ng-trigger ng-trigger-flip"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="flip-card-front ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="up ng-tns-c1798067373-0"
//                           >
//                             <div
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               5
//                             </div>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="flip-card-back ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="down ng-tns-c1798067373-0"
//                           >
//                             <div
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               <div
//                                 _ngcontent-ng-c1798067373=""
//                                 className="ng-tns-c1798067373-0"
//                               >
//                                 1
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </span>
//             </div>
//             {/**/}
//             <div
//               _ngcontent-ng-c1798067373=""
//               className="count-no ng-tns-c1798067373-0 ng-star-inserted"
//               style={{ marginRight: 80 }}
//             >
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0"
//               >
//                 <div
//                   _ngcontent-ng-c1798067373=""
//                   className="content ng-tns-c1798067373-0"
//                 >
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     style={{ position: "absolute" }}
//                     className="ng-tns-c1798067373-0"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       className="flip ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="up ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="ng-tns-c1798067373-0"
//                         >
//                           0
//                         </div>
//                       </div>
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="down ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="ng-tns-c1798067373-0"
//                           >
//                             0
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     style={{ position: "absolute" }}
//                     className="ng-tns-c1798067373-0"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       className="flip-card ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="flip-card-inner ng-tns-c1798067373-0 ng-trigger ng-trigger-flip"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="flip-card-front ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="up ng-tns-c1798067373-0"
//                           >
//                             <div
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               0
//                             </div>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="flip-card-back ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="down ng-tns-c1798067373-0"
//                           >
//                             <div
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               <div
//                                 _ngcontent-ng-c1798067373=""
//                                 className="ng-tns-c1798067373-0"
//                               >
//                                 0
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </span>
//             </div>
//             {/**/}
//           </div>
//         </div>
//         {/**/}
//         {/**/}
//         <div
//           _ngcontent-ng-c1798067373=""
//           className="casino-detail ng-tns-c1798067373-0"
//         >
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           {/**/}
//           <div
//             _ngcontent-ng-c1798067373=""
//             className="casino-detail ng-tns-c1798067373-0 ng-star-inserted"
//           >
//             <div
//               _ngcontent-ng-c1798067373=""
//               className="ball-by-ball ng-tns-c1798067373-0"
//             >
//               <div
//                 _ngcontent-ng-c1798067373=""
//                 className="game-market market-6 ng-tns-c1798067373-0"
//               >
//                 <div
//                   _ngcontent-ng-c1798067373=""
//                   className="market-title ng-tns-c1798067373-0"
//                 >
//                   Runs
//                 </div>
//                 <div
//                   _ngcontent-ng-c1798067373=""
//                   className="market-header row ng-tns-c1798067373-0"
//                 >
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       className="market-row ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-nation-detail ng-tns-c1798067373-0"
//                       />
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-odd-box back ng-tns-c1798067373-0"
//                       >
//                         <b
//                           _ngcontent-ng-c1798067373=""
//                           className="ng-tns-c1798067373-0"
//                         >
//                           Back
//                         </b>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       className="market-row ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-nation-detail ng-tns-c1798067373-0"
//                       />
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-odd-box back ng-tns-c1798067373-0"
//                       >
//                         <b
//                           _ngcontent-ng-c1798067373=""
//                           className="ng-tns-c1798067373-0"
//                         >
//                           Back
//                         </b>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 d-none d-md-block ng-tns-c1798067373-0"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       className="market-row ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-nation-detail ng-tns-c1798067373-0"
//                       />
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-odd-box back ng-tns-c1798067373-0"
//                       >
//                         <b
//                           _ngcontent-ng-c1798067373=""
//                           className="ng-tns-c1798067373-0"
//                         >
//                           Back
//                         </b>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="fancy-min-max-box ng-tns-c1798067373-0"
//                   />
//                 </div>
//                 <div
//                   _ngcontent-ng-c1798067373=""
//                   className="market-body row ng-tns-c1798067373-0"
//                 >
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             0 Runs
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               2.18
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 25000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             1 Runs
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               2.63
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 25000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             2 Runs
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               7.86
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 25000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             3 Runs
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               11
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 25000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             4 Runs
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               6.54
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 25000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             6 Runs
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               11.86
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 20000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             Boundary
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               4.22
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 25000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             Wicket
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               6.92
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 25000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   <div
//                     _ngcontent-ng-c1798067373=""
//                     className="col-6 col-md-4 ng-tns-c1798067373-0 ng-star-inserted"
//                   >
//                     <div
//                       _ngcontent-ng-c1798067373=""
//                       data-title="SUSPENDED"
//                       className="fancy-market ng-tns-c1798067373-0"
//                     >
//                       <div
//                         _ngcontent-ng-c1798067373=""
//                         className="market-row ng-tns-c1798067373-0"
//                       >
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="market-nation-detail ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="market-nation-name pointer ng-tns-c1798067373-0"
//                           >
//                             Extra Runs
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             id="book_1"
//                             className="float-left book ng-tns-c1798067373-0"
//                             style={{ color: "black" }}
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </span>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="blb-box ng-tns-c1798067373-0"
//                         >
//                           <div
//                             _ngcontent-ng-c1798067373=""
//                             className="market-odd-box back ng-tns-c1798067373-0"
//                           >
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-odd ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               8.61
//                             </span>
//                             <span
//                               _ngcontent-ng-c1798067373=""
//                               className="market-volume ng-tns-c1798067373-0"
//                             >
//                               {" "}
//                               0{" "}
//                             </span>
//                           </div>
//                         </div>
//                         <div
//                           _ngcontent-ng-c1798067373=""
//                           className="fancy-min-max ng-tns-c1798067373-0"
//                         >
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Min: 50
//                           </span>
//                           <span
//                             _ngcontent-ng-c1798067373=""
//                             className="w-100 d-block ng-tns-c1798067373-0"
//                           >
//                             Max: 25000
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   {/**/}
//                   {/**/}
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/**/}
//           <div
//             _ngcontent-ng-c1798067373=""
//             className="ng-tns-c1798067373-0"
//           >
//             <div
//               _ngcontent-ng-c1798067373=""
//               className="casino-last-result-title ng-tns-c1798067373-0"
//             >
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0"
//               >
//                 Last Result
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0"
//               >
//                 <a
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   View All
//                 </a>
//               </span>
//             </div>
//             <div
//               _ngcontent-ng-c1798067373=""
//               className="casino-last-results ng-tns-c1798067373-0 ng-star-inserted"
//             >
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               <span
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0 result ng-star-inserted"
//               >
//                 <span
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   {" "}
//                   R
//                 </span>
//               </span>
//               {/**/}
//               {/**/}
//               {/**/}
//               {/**/}
//               {/**/}
//             </div>
//             {/**/}
//           </div>
//         </div>
//       </div>
//       <div
//         _ngcontent-ng-c1798067373=""
//         className="ng-tns-c1798067373-0 d-none matchbettable w-100 ng-star-inserted"
//       >
//         <div
//           _ngcontent-ng-c1798067373=""
//           className="table-responsive ng-tns-c1798067373-0"
//         >
//           <table
//             _ngcontent-ng-c1798067373=""
//             className="table ng-tns-c1798067373-0"
//           >
//             <thead
//               _ngcontent-ng-c1798067373=""
//               className="ng-tns-c1798067373-0"
//             >
//               <tr
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0"
//               >
//                 <th
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   Matched Bet
//                 </th>
//                 <th
//                   _ngcontent-ng-c1798067373=""
//                   className="text-end ng-tns-c1798067373-0"
//                 >
//                   Odds
//                 </th>
//                 <th
//                   _ngcontent-ng-c1798067373=""
//                   className="text-end ng-tns-c1798067373-0"
//                 >
//                   Stake
//                 </th>
//               </tr>
//             </thead>
//             {/**/}
//           </table>
//         </div>
//       </div>
//       {/**/}
//       {/**/}
//     </div>
//     {/**/}
//   </div>
//   <div
//     _ngcontent-ng-c1798067373=""
//     className="sidebar right-sidebar casino-right-sidebar ng-tns-c1798067373-0"
//   >
//     <div
//       _ngcontent-ng-c1798067373=""
//       className="sidebar-box place-bet-container d-xl-block d-none ng-tns-c1798067373-0"
//     >
//       {/**/}
//       <div
//         _ngcontent-ng-c1798067373=""
//         className="sidebar-title ng-tns-c1798067373-0"
//       >
//         <h4 _ngcontent-ng-c1798067373="" className="ng-tns-c1798067373-0">
//           Place Bet
//         </h4>
//       </div>
//       {/**/}
//     </div>
//     <div
//       _ngcontent-ng-c1798067373=""
//       className="sidebar-box my-bet-container d-xl-block d-none ng-tns-c1798067373-0"
//     >
//       <div
//         _ngcontent-ng-c1798067373=""
//         className="sidebar-title ng-tns-c1798067373-0"
//       >
//         <h4 _ngcontent-ng-c1798067373="" className="ng-tns-c1798067373-0">
//           My Bet
//         </h4>
//         <a
//           _ngcontent-ng-c1798067373=""
//           className="sideviewmore ng-tns-c1798067373-0"
//         >
//           View more
//         </a>
//       </div>
//       <div
//         _ngcontent-ng-c1798067373=""
//         className="my-bets ng-tns-c1798067373-0"
//       >
//         <div
//           _ngcontent-ng-c1798067373=""
//           className="table-responsive w-100 ng-tns-c1798067373-0"
//         >
//           <table
//             _ngcontent-ng-c1798067373=""
//             className="table ng-tns-c1798067373-0"
//           >
//             <thead
//               _ngcontent-ng-c1798067373=""
//               className="ng-tns-c1798067373-0"
//             >
//               <tr
//                 _ngcontent-ng-c1798067373=""
//                 className="ng-tns-c1798067373-0"
//               >
//                 <th
//                   _ngcontent-ng-c1798067373=""
//                   className="ng-tns-c1798067373-0"
//                 >
//                   Matched Bet
//                 </th>
//                 <th
//                   _ngcontent-ng-c1798067373=""
//                   className="text-end ng-tns-c1798067373-0"
//                 >
//                   Odds
//                 </th>
//                 <th
//                   _ngcontent-ng-c1798067373=""
//                   className="text-end ng-tns-c1798067373-0"
//                 >
//                   Stake
//                 </th>
//               </tr>
//             </thead>
//             {/**/}
//           </table>
//         </div>
//       </div>
//     </div>
//     <div
//       _ngcontent-ng-c1798067373=""
//       className="sidebar-box sidebar-box-rules my-bet-container ng-tns-c1798067373-0"
//     >
//       <app-casino-game-rules
//         _ngcontent-ng-c1798067373=""
//         className="ng-tns-c1798067373-0"
//         _nghost-ng-c1761710207=""
//       >
//         {/**/}
//         {/**/}
//         {/**/}
//         {/**/}
//       </app-casino-game-rules>
//     </div>
//   </div>
// </div>

import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function BallByBall() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  const VIDEO_ID = "ballbyball";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      gameName={"Ball By Ball"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container ball-by-ball"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
              Ball By Ball
              <a className="ms-1">
                <small>Rules</small>
              </a>
            </span> */}
      {/* <span className="casino-rid d-none d-xl-inline-block">
              <small>
                Round ID: <span>5539609302963</span>
              </small>
            </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none"> */}
      {/* <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul> */}
      {/* <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>5539609302963</span>
              </span>
            </div> */}
      {/* </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/ballbyball/83f60018-aadf-43ca-8430-2a9e645d28e5?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">8</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">7</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail detail-page-container position-relative">
        <div className="game-market market-6 container-fluid container-fluid-5">
          <div className="market-title row row5">Runs</div>
          <div className="market-header row row5">
            <div className="col-12 col-md-4 d-none d-md-block">
              <div className="market-row">
                <div className="market-nation-detail" />
                <div className="market-odd-box back">
                  <b>Back</b>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 d-none d-md-block">
              <div className="market-row">
                <div className="market-nation-detail" />
                <div className="market-odd-box back">
                  <b>Back</b>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="market-row">
                <div className="market-nation-detail" />
                <div className="market-odd-box back">
                  <b>Back</b>
                </div>
              </div>
            </div>
            <div className="fancy-min-max-box" />
          </div>
          <div className="market-body row row5">
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      0 Runs
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "0 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("0 Runs", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {" "}
                          {getOddForEntity("0 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("0 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      1 Runs
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "1 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("1 Runs", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {" "}
                          {getOddForEntity("1 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {" "}
                          {getOddForEntity("1 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      2 Runs
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "2 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("2 Runs", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {" "}
                          {getOddForEntity("2 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {" "}
                          {getOddForEntity("2 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      3 Runs
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "3 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("3 Runs", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {" "}
                          {getOddForEntity("3 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("3 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      4 Runs
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "4 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("4 Runs", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {" "}
                          {getOddForEntity("4 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("4 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      6 Runs
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "6 Runs")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("6 Runs", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {getOddForEntity("6 Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("6 Runs", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 20K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      Boundary
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Boundary")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Boundary", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {getOddForEntity("Boundary", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("Boundary", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      Wicket
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(casinoPlData, "Wicket")}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Wicket", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {getOddForEntity("Wicket", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity("Wicket", casinoData, true, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="fancy-market" data-title="OPEN">
                <div className="market-row">
                  <div className="market-nation-detail">
                    <span className="market-nation-name pointer">
                      Extra Runs
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Extra Runs"
                        )}
                      </p>
                    </span>
                  </div>
                  <div className=" blb-box ">
                    <div className="market-odd-box back ">
                      <div
                        className={`casino-odds-box back  ${
                          casinoData?.data?.response?.autoTime < 5
                            ? "suspended-box"
                            : ""
                        }`}
                        onClick={() =>
                          setBet("Extra Runs", casinoData, dispatch, "back")
                        }
                      >
                        <span className="market-odd">
                          {getOddForEntity("Extra Runs", casinoData, true)}
                        </span>
                        <span className="market-volume">
                          {getOddForEntity(
                            "Extra Runs",
                            casinoData,
                            true,
                            true
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="fancy-min-max-box">
                    <div className="fancy-min-max">
                      <span className="w-100 d-block">Min: 50.00</span>
                      <span className="w-100 d-block">Max: 25K</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="casino-remark mt-1">
          <div className="remark-icon">
            <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/remark.png" />
          </div>
          <marquee scrollamount={3}>
            Results are based on stream only. Score board may be different or
            updated later.
          </marquee>
        </div>
        {/* <div className="casino-last-result-title">
          <span>Last Result</span>
          <span>
            <a href="/casino-results/ballbyball">View All</a>
          </span>
        </div> */}
        {/* <div className="casino-last-results">
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
          <span className="result result-b">R</span>
        </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive w-100">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
